import { AfterViewInit, Component, OnInit } from '@angular/core';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { DialogModel } from '@shared/models/dialog.model';
import {NgxQuillEditorService} from '@shared/services/ngx-quill-editor.service';

@Component({
    standalone: false,
    selector: 'app-platform-tool-edit-section-editor',
  templateUrl: './platform-tool-edit-section-editor.component.html',
  styleUrls: ['./platform-tool-edit-section-editor.component.scss']
})
export class PlatformToolEditSectionEditorComponent implements OnInit, IDialogView, AfterViewInit {

  data: DialogModel;
  public modules: any;

  constructor(private ngxQuillEditorService: NgxQuillEditorService) {
    this.modules = this.ngxQuillEditorService.getQuillEditorOptions();
  }

  ngOnInit() {

  }
  ngAfterViewInit (): void {
  }
  onOkClicked(): boolean {
    if (!this.data.input.name || this.data.input.name.length === 0) {
      return false;
    }
    return true;
  }
}
